module.exports = __webpack_public_path__ + "media/streaming_reel.c470c649.mp4";